import {createAction, props} from '@ngrx/store';
import {GlobalOptions} from '../../interfaces/global-options';

export const setGlobalOptions = createAction(
  '[Object] Set Object for Pull Up',
  props<{options: GlobalOptions}>()
);


